module.exports = __webpack_public_path__ + "img/Sinaloa.4a3cfb5e.svg";